var exports = {
  "x6": "x2b2fbebb--672cf2--button",
  "Pf": "x2b2fbebb--672cf2--label",
  "kv": "x2b2fbebb--672cf2--checkbox",
};

module.exports = exports;
